<template>
  <div>

    <v-layout align-center justify-center row fill-height>

      <v-flex xs9>
        <v-card>

          <v-tabs
            centered
            color="white"

            icons-and-text
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab href="#tab-1">
              Tamaño
              <v-icon>receipt</v-icon>
            </v-tab>

            <v-tab href="#tab-2">
              Cobertura
              <v-icon>public</v-icon>
            </v-tab>

            <v-tab-item
              :value="'tab-2'"
            >
              <v-card flat >
                <data-table
                :headers="headersCobertura"
                :dataVals="dataValsCobertura"
                :searchActive="true"
                :key="'2'"
                disable-initial-sort
              />
              </v-card>
            </v-tab-item>

            <v-tab-item
              :value="'tab-1'"
            >
              <v-card flat>
                <data-table
                :headers="headersTamaños"
                :dataVals="dataValsTamaños"
                :searchActive="true"
                :key="'1'"
                disable-initial-sort
              />
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import chartLine from '@/components/Charts/LineBase'
// import dataTable from '@/components/Tables/TableBase'
import dataTable from '@/components/Tables/TableWithTotals'
// import JsonCSV from 'vue-json-csv'

export default {

  name: 'Cobertura',
  components: {
    // 'chart-line': chartLine,
    'data-table': dataTable
    // 'download-csv': JsonCSV
  },
  data () {
    return {
      backConf: {
        path: '/projects/ros_empl/' // poner PATH Aqui
      },
      operativo: null,
      datos: null,
      search: null,

      // variables para saber por medio de peticion
      // si aplica o no reportes de cada tipo.

      mensaje: null,

      dataVals: null,
      labels: null,
      fields: null,

      tableKeyMuestra: 0,

      headersTamaños: [],
      dataValsTamaños: [],
      labelsTamaños: [],

      headersCobertura: [],
      dataValsCobertura: [],
      labelsCobertura: [],

      ponder: 0,
      ponder2: 0,

      totMeta: 0,
      totCont: 0,

      totCont2: 0,
      totMeta2: 0
    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.getTabla()
  },

  methods: {
    getTabla () {
      this.loading = true
      this.data = null
      let request = {
        method: 'get',
        url: this.backConf.path
        // params: {
        //   operativo: this.operativo
        // }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let tamaños = Object.keys(resp.data[0][0])

          resp.data[0].forEach(function (element) {
            t.totMeta += element.Meta
            t.totCont += element.Conteo

            let perc = element.Conteo / element.Meta * 100
            perc = Number.parseFloat(perc).toFixed(1)

            let obj = {
              Tamaño: element.Tamaño,
              Meta: element.Meta,
              Conteo: element.Conteo,
              Porcentaje: perc === 'NaN' ? Number.parseFloat(0).toFixed(1) : perc
            }
            // agrega las keys y los valores de los values, para mostrar
            tamaños.forEach(function (key) {
              obj[key] = element[key]
            })

            t.dataValsTamaños.push(obj)
          })

          t.ponder = t.totCont / t.totMeta * 100

          // -------------------------------------------------
          let coberturas = Object.keys(resp.data[1][0])

          resp.data[1].forEach(function (element2) {
            t.totMeta2 += element2.Meta
            t.totCont2 += element2.Conteo

            let perc = element2.Conteo / element2.Meta * 100
            perc = Number.parseFloat(perc).toFixed(1)

            let obj = {
              Comuna: element2.Comuna,
              Meta: element2.Meta,
              Conteo: element2.Conteo,
              Porcentaje: perc === 'NaN' ? Number.parseFloat(0).toFixed(1) : perc
            }
            // agrega las keys y los valores de los values, para mostrar
            coberturas.forEach(function (key) {
              obj[key] = element2[key]
            })

            t.dataValsCobertura.push(obj)
          })
          t.ponder2 = t.totCont2 / t.totMeta2 * 100

          t.updateTable(tamaños, coberturas)
        })
        .catch(err => console.error(err))
    },
    /**
     * Función que actualiza los datos de headers de la tabla
     */

    updateTable (arreglo, arrCobertura) {
      let pp = String(parseFloat(this.ponder).toFixed(2)) + ' %'
      let Cmeta = this.totMeta
      let Cconteo = this.totCont

      let head = []
      let labs = []

      arreglo.forEach(function (k, index) {
        if (k === 'Tamaño') {
          head.unshift(
            { text: k, value: k, str: '', align: '' }
          )
        } else if (k === 'Meta') {
          head.push(
            { text: k, value: k, str: Cmeta, align: 'right' }
          )
        } else if (k === 'Conteo') {
          head.push(
            { text: k, value: k, str: Cconteo, align: 'right' }
          )
        } else {
          head.push(
            { text: k, value: k, str: pp, width: '5%', align: '' }
          )
        }
        labs[k] = k
      })
      head.push(
        { text: 'Avance %', value: 'Porcentaje', align: 'right', str: pp }
      )

      head[0].str = 'Totales'
      this.headersTamaños = head

      // ---------------------------------------------------------------------
      let pp2 = String(parseFloat(this.ponder2).toFixed(2)) + ' %'
      let keys2 = arrCobertura
      let Cmeta2 = this.totMeta2
      let Cconteo2 = this.totCont2

      let head2 = []
      let labs2 = []

      keys2.forEach(function (k, index) {
        if (k === 'Comuna') {
          head2.unshift(
            { text: k, value: k, str: '', align: '' }
          )
        } else if (k === 'Meta') {
          head2.push(
            { text: k, value: k, str: Cmeta2, align: 'right' }
          )
        } else if (k === 'Conteo') {
          head2.push(
            { text: k, value: k, str: Cconteo2, align: 'right' }
          )
        } else {
          head2.push(
            { text: k, value: k, str: ' ', width: '5%', align: '' }
          )
        }
        labs2[k] = k
      })
      head2.push(
        { text: 'Avance %', value: 'Porcentaje', align: 'right', str: pp2 }
      )
      head2[0].str = 'Totales'
      this.headersCobertura = head2
    }

  }
}
</script>
